import request from '@/services/helpers/request';
import { API_ROUTES } from '@/config';

export const fetchAll = async () => (await request.getInstance()).get(API_ROUTES.logs.fetchAll);
